import { createColumnHelper } from '@tanstack/react-table';
import React from 'react';
import DataTableV3 from 'src/components/DataTableV3';
import { CountyWithMunicipalities, Municipalities } from 'src/features/one-way-in/hooks/use-geonorge';

type SelectedCountyWithMunicipalities = CountyWithMunicipalities & {
  totalMunicipalityCount: number;
};

type Props = {
  countiesWithMunicipalities: SelectedCountyWithMunicipalities[];
};

const SelectedCountiesTable: React.FC<Props> = ({ countiesWithMunicipalities }) => {
  return (
    <div>
      <DataTableV3
        data={countiesWithMunicipalities}
        columns={countyColumns}
        id={''}
        disableSelection
        disablePagination
        disableColumnEditor
        disableGlobalFilter
        disableExport
        hideFilterText
        hideScrollbar
        getRowCanExpand={() => true}
        renderSubComponent={({ row }) => <MunicipalityList selected={row.original.kommuner} />}
        placeholderText="Vennligst legg til fylker eller kommuner"
      />
    </div>
  );
};

export default SelectedCountiesTable;

type MunicipalityListProps = {
  selected: Municipalities[];
};

const MunicipalityList: React.FC<MunicipalityListProps> = ({ selected }) => {
  return (
    <div>
      {selected.map((municipality) => (
        <div className="margin-left--5 margin-bottom--2" key={municipality.kommunenummer}>
          {municipality.kommunenavnNorsk}
        </div>
      ))}
    </div>
  );
};

const columnHelper = createColumnHelper<SelectedCountyWithMunicipalities>();

export const countyColumns = [
  columnHelper.accessor((row) => row.fylkesnavn, {
    id: 'Fylke',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.kommuner, {
    id: 'Antall valgte kommuner',
    cell: (info) => {
      return <span>{`${info.getValue().length}/${info.row.original.totalMunicipalityCount}`}</span>;
    },
  }),
];
